import type {Document} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class VisitedDocumentsDataService {
    public static serviceName = 'visitedDocumentsDataService';

    public static readonly DOCUMENTS_VISITED_ROUTE = 'documents/visited';


    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getVisitedDocuments(withLastVisited?: boolean): Promise<Document[]> {
        return this.ajaxService
            .createRequest(`${VisitedDocumentsDataService.DOCUMENTS_VISITED_ROUTE}`)
            .get({withLast: withLastVisited});
    }
}
